module.exports = __webpack_public_path__ + "img/9788964372517.c793e062.jpg";